// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TimelineViewMenuBottomSheet-content__gX8R8{display:flex;flex-direction:column;gap:var(--size-0_5);align-items:flex-start;align-self:stretch;padding:var(--size-2) var(--size-3)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": "TimelineViewMenuBottomSheet-content__gX8R8"
};
export default ___CSS_LOADER_EXPORT___;
